/* DON'T EDIT THIS FILE: edit original and run build again */ import { toArray } from "../../framework/core/maybe-array.ts";
import {
  typeCheckerError,
  typeCheckerOkResult,
  typeCheckerSchemaFailResult,
} from "./type-checker-errors.ts";
import { typeCheckerResolveResult } from "./type-checker-resolve-result.ts";
import {
  TypeCheckerArraySchema,
  TypeCheckerError,
  TypeCheckerErrorType,
  TypeCheckerRecurseChecker,
  TypeCheckerResult,
  TypeCheckerStatus,
  WithAnyTypeCheckerSchemaOptions,
} from "./type-checker-types.ts";

export const typeCheckerCheckArray = (
  checker: WithAnyTypeCheckerSchemaOptions<TypeCheckerArraySchema>,
  value: unknown,
  path: string,
  check: TypeCheckerRecurseChecker
): TypeCheckerResult => {
  if (!Array.isArray(value)) {
    return typeCheckerResolveResult(
      checker,
      value,
      path,
      typeCheckerSchemaFailResult(value, path)
    );
  }
  const orSchemas = toArray(checker.schema);
  const validated: any = [];
  const errors: TypeCheckerError[] = [];
  for (let i = 0; i < value.length; ++i) {
    const idxPath = path + "[" + i + "]";
    let itemResult: TypeCheckerResult = typeCheckerSchemaFailResult(
      value,
      path
    );
    for (let j = 0; j < orSchemas.length; ++j) {
      itemResult = check(orSchemas[j], value[i], idxPath);
      if (itemResult.status === TypeCheckerStatus.ok) {
        break;
      }
    }
    if (itemResult.status === TypeCheckerStatus.ok) {
      validated.push(itemResult.value);
      errors.push(...itemResult.errors);
    } else if (checker.skipInvalid) {
      errors.push(
        typeCheckerError(TypeCheckerErrorType.skippedInvalid, value[i], idxPath)
      );
    } else {
      return itemResult;
    }
  }
  return typeCheckerOkResult(validated, errors);
};
